module.exports = __webpack_public_path__ + "static/media/Project3_Cover.a9ddac13.png";